import { EditVenueModal } from "./EditVenueModal";

export default EditVenueModal;
